import { useRowSelection } from "@/contexts/RowSelection/useRowSelection";
import { useCustomParams } from "@/hooks/useCustomParams";
import { Recording } from "@/models/recording";
import { ButtonSize, ButtonVariant, ChevronDownIcon, ChevronUpIcon, EditIcon, HorizontalFlex, IconButton, Space, UploadIcon } from "@enxcs/dap-ui-stratos";
import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { RecordingTableRowActions } from "../RecordingTable/RecordingTableRowActions";

interface RecordsActionsProps {
  record: Recording;
  onUpload: () => void;
}

const RecordsActions: FC<RecordsActionsProps> = ({ record, onUpload }) => {
  const { page, rowsPerPage, orderByColumn, isAscending, searchTerm, sorting } = useCustomParams();

  const { expandedRows, onAddExpandedRow } = useRowSelection();

  const navigate = useNavigate();

  const { t, i18n } = useTranslation();

  const params = { page, rowsPerPage, orderByColumn, isAscending, searchTerm, sorting };

  const { recordingId, exports = [] } = record;

  const hasExports = exports?.length;

  const handleEdit = () => {
    navigate(`/${i18n.language}/editing/${recordingId}`, {
      state: { ...params },
    });
  };

  return (
    <HorizontalFlex $justify={"flex-end"} $padRight={hasExports ? ("0" as Space) : ("36px" as Space)} $gap={Space.V4}>
      {!hasExports ? (
        <>
          <IconButton icon={EditIcon} title={t("buttons.edit")} size={ButtonSize.S} onClick={handleEdit} />
          <IconButton icon={UploadIcon} title={t("buttons.export")} size={ButtonSize.S} onClick={onUpload} />
        </>
      ) : null}
      <RecordingTableRowActions record={record} handleEdit={handleEdit} onUpload={onUpload} />
      {hasExports > 0 ? (
        <IconButton
          icon={expandedRows.includes(recordingId) ? ChevronUpIcon : ChevronDownIcon}
          title={t("buttons.expandCollapse")}
          variant={ButtonVariant.GHOST}
          size={ButtonSize.S}
          onClick={() => onAddExpandedRow(recordingId)}
        />
      ) : null}
    </HorizontalFlex>
  );
};

export default RecordsActions;
